export default {"src":"/_next/static/media/house.dbfd8e32.svg","height":25,"width":30,"blurWidth":0,"blurHeight":0};